import { ChangeDetectorRef, Component, DestroyRef, inject, Input } from '@angular/core';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { map } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { Bild } from '../../../models/unterlagen.model';
import { AsyncPipe } from '@angular/common';
import { Button } from 'primeng/button';
import { MessagingService } from '../../../services/messaging.service';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { Card } from 'primeng/card';

type ImageFilter = 'grayscale(100%)' | '';

@Component({
  selector: 'app-foto[control]',
  templateUrl: './foto.component.html',
  styleUrls: ['./foto.component.scss'],
  imports: [ImageCropperComponent, ReactiveFormsModule, AsyncPipe, Button, ToggleSwitch, Card],
  standalone: true
})
export class FotoComponent {
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  protected croppedImage: string = '';
  protected imageChangedEvent?: Event;
  protected hasValidImage: boolean = false;

  @Input()
  public control!: FormControl<Bild | null>;
  protected blackWhite: FormControl<boolean> = new FormControl<boolean>(false, { nonNullable: true });
  protected imageFilter: Observable<ImageFilter> = this.blackWhite.valueChanges.pipe(
    map((value: boolean): ImageFilter => {
      if (value) {
        return 'grayscale(100%)';
      }
      return '';
    })
  );

  public constructor(private readonly messagingService: MessagingService) {
    this.blackWhite.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: boolean): void => {
      if (this.control.value === null) {
        return;
      }
      this.control.setValue({ src: this.control.value.src, grayscale: value });
    });
  }

  protected imageCropped(event: ImageCroppedEvent): void {
    if (event.blob !== undefined && event.blob !== null) {
      const reader: FileReader = new FileReader();

      reader.onloadend = (): void => {
        const result: string | null = reader.result as string | null;
        if (result === null) {
          this.croppedImage = '';
          this.control.setValue(null);
          return;
        }

        this.croppedImage = result;
        this.control.setValue({ src: result, grayscale: this.blackWhite.value });
        this.cdr.detectChanges();
      };

      reader.readAsDataURL(event.blob);
      this.hasValidImage = true;
    } else {
      this.croppedImage = '';
      this.control.setValue(null);
    }
  }

  public loadImageFailed(): void {
    this.messagingService.showTechnicalErrorToast('Bild konnte nicht geladen werden.');
    this.resetImage();
  }

  protected resetImage(fileInput?: HTMLInputElement): void {
    this.hasValidImage = false;
    this.croppedImage = '';
    this.imageChangedEvent = undefined;
    this.control.setValue(null);
    this.blackWhite.setValue(false, { emitEvent: false });
    if (fileInput !== undefined) {
      fileInput.value = '';
    }
  }
}
